export const WebModule = Symbol('WebModule');

export default interface IWebModule {
  getRoutes(): JSX.Element;
}
